export const CheckPatientStatusColor = (status: string) => {
  if (status === 'active') {
    return 'text-midBlue capitalize';
  } else if (status === 'inactive') {
    return 'text-red capitalize';
  }
};
